import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";

// NOTE: Vanilla JS app in public/index.html is the main app
// React renders an empty component to prevent HMR flickering
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<React.StrictMode><></></React.StrictMode>);

// Service Worker temporarily disabled to prevent reload issues
// if ('serviceWorker' in navigator) {
//   window.addEventListener('load', () => {
//     navigator.serviceWorker.register('/sw.js')
//       .then((registration) => {
//         console.log('UBA Deliverance PWA: Service Worker registered successfully:', registration);
//       })
//       .catch((error) => {
//         console.error('UBA Deliverance PWA: Service Worker registration failed:', error);
//       });
//   });
// }

// Notifications temporarily disabled
// if ('Notification' in window && 'serviceWorker' in navigator) {
//   Notification.requestPermission().then((permission) => {
//     if (permission === 'granted') {
//       console.log('UBA Deliverance PWA: Notification permission granted');
//     }
//   });
// }
